import { CheckedAddress } from '@sparkdotfi/common-universal'

import {
  InterestRateModelChart,
  InterestRateModelChartProps,
} from '../charts/interest-rate-model/InterestRateModelChart'
import { formatPercentage } from '@/domain/common/format'
import { InfoTile } from '@/features/sparklend/market-details/components/info-tile/InfoTile'
import { Panel } from '@/ui/atoms/panel/Panel'
import { BlockExplorerAddressLink } from '@/ui/molecules/block-explorer-address-link/BlockExplorerAddressLink'

export interface InterestRateModelPanelProps extends InterestRateModelChartProps {
  chainId: number
  interestRateStrategyAddress: CheckedAddress
}

export function InterestRateModelPanel({
  interestRateStrategyAddress,
  chainId,
  ...chartProps
}: InterestRateModelPanelProps) {
  return (
    <Panel className="flex flex-col gap-4">
      <h3 className="typography-label-1 text-primary">Interest Rate Model</h3>
      <div className="flex flex-col gap-4 sm:gap-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:gap-10">
          <InfoTile>
            <InfoTile.Label>Utilization Rate</InfoTile.Label>
            <InfoTile.Value>{formatPercentage(chartProps.utilizationRate)}</InfoTile.Value>
          </InfoTile>
          <InfoTile>
            <InfoTile.Label>Contract</InfoTile.Label>
            <InfoTile.Value className="w-full">
              <BlockExplorerAddressLink address={interestRateStrategyAddress} chainId={chainId} />
            </InfoTile.Value>
          </InfoTile>
        </div>
      </div>
      <InterestRateModelChart {...chartProps} />
    </Panel>
  )
}
